import 'css-chunksrc/feature/check-item-discount/CheckItemDiscountModal.module.scss';export default {
  "autoDiscount": "CheckItemDiscountModal_autoDiscount",
  "manualDiscount": "CheckItemDiscountModal_manualDiscount",
  "grid": "CheckItemDiscountModal_grid",
  "divider": "CheckItemDiscountModal_divider",
  "cta": "CheckItemDiscountModal_cta"
};